import { Component, HostListener, Output, EventEmitter, ElementRef, ViewChild, AfterViewInit, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { DialogService } from '../../../services/dialog.service';
import { OrderService } from '../../../services/order.service';
import { TodayCountsService } from '../../../services/today-counts.service';
import { QuickStatsFilterService } from '../../../services/quick-stats-filter.service';
import { DatePipe } from '@angular/common';
import { AuthServiceService } from '@app/services/auth-service.service';
import { ToastrService } from 'ngx-toastr';
import { debounceTime, distinctUntilChanged, Subject, Subscription, takeUntil, forkJoin, skip } from 'rxjs';
import { WebsocketService } from '@app/services/websocket.service';
import { WebsocketRefreshService } from '@app/services/websocket-refresh.service';
import { ShareddtaService } from '@app/services/shareddta.service';
import { NavigationserviceService } from '@app/services/navigationservice.service';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { ToastService } from '@app/services/toast.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ReusableGoogleMapComponent } from '@app/components/reusable-google-map/reusable-google-map.component';
import { BreadcrumbService } from '@app/services/breadcrumb.service';
export interface Order {
  id: string;
  orderId: string;
  orderIcon: string;
  orderType: 'delivery' | 'pickup';
  customerName: string;
  customerCompany: string;
  address: string;
  deliveryDate: string;
  committedTime: string;
  deliveryTime: string;
  driverInitials: string;
  status: 'pending' | 'successful' | 'unsuccessful' | 'cancelled';
  eta: string;
  selected?: boolean;
  driverName: string
}

@Component({
  selector: 'app-order-list',
  templateUrl: './order-list.component.html',
  styleUrl: './order-list.component.scss'
})
export class OrderListComponent implements OnInit, AfterViewInit, OnDestroy {
  currentFilter: string = 'all';
  totalOrders: number = 0;
  pendingCount: number = 0;
  successfulCount: number = 0;
  unsuccessfulCount: number = 0;
  cancelledCount: number = 0;
  arrivedCount: number = 0;
  shippedCount: number = 0;
  enRouteCount: number = 0;
  warehouseCount: number = 0;
  todayDelivery: number = 0;
  active_driver_count: number = 0;
  todayPickup: number = 0;
  todayTotalDP: number = 0;
  Object = Object;

  // Emit today's counts to header
  @Output() todayCountsUpdated = new EventEmitter<{ delivery: number, pickup: number, total: number, active_driver_count: number }>();
  // Date filter
  selectedDate: string = '';

  // Advanced filters
  showAdvancedFilters: boolean = false;
  advancedFilters = {
    customerName: '',
    company: '',
    driver: '',
    city: '',
    dateFrom: '',
    dateTo: ''
  };

  // Column filters
  showDriverFilter: boolean = false;
  showStatusFilter: boolean = false;
  selectedDrivers: string[] = [];
  selectedStatuses: string[] = [];

  // Orders data
  allOrders: Order[] = [];
  orders: any = [];
  filteredOrders: Order[] = [];
  displayedOrders: Order[] = [];

  // Pagination
  pageSize: number = 20;
  currentPage: number = 0;
  isLoading: boolean = true;
  hasMore: boolean = true;
  scrollProgress: number = 0;
  isRestoringScroll: boolean = false; // 🔒 Scroll Lock flag
  isReturningFromDetail: boolean = false; // Component-level guard

  // Selection
  selectedCount: number = 0;
  showBulkActions: boolean = false;

  // Dropdown states
  activeDropdown: string | null = null;
  searchtext: any;
  orderDate: any;
  orderType: any;
  driverId: any;
  orderStatus: any;
  todaysDate: any;
  activeGroupDriverId: any = null;
  activeGroupStatus: any = null;
  activeGroupDate: string | null = null;
  groupSelectionActive: boolean = false;
  totalOrderscount: any;
  isTruckExpanded: boolean = false;
  isZoneExpanded: boolean = false;
  isSyncingReturnFlow: boolean = false; // 🔄 Industry-standard sync lock
  isProcessingDrop: boolean = false; // 🔒 Lock to ignore socket refreshes during drag-drop transitions

  // 🔹 Dynamic Range Tracking
  visibleRangeStart: number = 1;
  visibleRangeEnd: number = 20;

  // Drag-and-drop state
  idsss: any;
  sttusses: any;
  currentDriverId: any;
  dropIndex: any;
  dragdrivername: any;
  priorityStarts: boolean = false;
  prioritystart: boolean = false;
  scrollSpeed: number = 30;
  scrollMargin: number = 50;

  get truckDrivers(): any[] {
    return this.driverList ? this.driverList.filter((d: any) =>
      d.is_virtual_user === true && d.first_name?.toLowerCase().includes('truck')
    ) : [];
  }

  get zoneDrivers(): any[] {
    if (!this.driverList) return [];
    const filtered = this.driverList.filter((d: any) =>
      d.is_virtual_user === true && !d.first_name?.toLowerCase().includes('truck')
    );

    const zoneOrder = ['north', 'east', 'south', 'west'];
    const getZoneIndex = (name: string): number => {
      const lower = (name || '').toLowerCase();
      for (let i = 0; i < zoneOrder.length; i++) {
        if (lower.includes(zoneOrder[i])) {
          return i;
        }
      }
      return 999;
    };

    return filtered.sort((a: any, b: any) => {
      const idxA = getZoneIndex(a.first_name);
      const idxB = getZoneIndex(b.first_name);
      if (idxA !== idxB) {
        return idxA - idxB;
      }
      return (a.first_name || '').localeCompare(b.first_name || '');
    });
  }

  get regularDrivers(): any[] {
    return this.driverList ? this.driverList.filter((d: any) =>
      d.is_virtual_user !== true
    ) : [];
  }

  get isAnyTruckSelected(): boolean {
    return this.truckDrivers.some(td => this.selectedDrivers.includes(td.id));
  }

  get isAnyZoneSelected(): boolean {
    return this.zoneDrivers.some(zd => this.selectedDrivers.includes(zd.id));
  }

  get isAnyFilterActive(): boolean {
    return !!this.searchtext ||
      !!this.orderDate ||
      this.selectedDrivers.length > 0 ||
      this.selectedStatuses.length > 0 ||
      (this.currentFilter !== 'all' && this.currentFilter !== '') ||
      !!this.orderType;
  }
  constructor(
    private router: Router,
    private dialogService: DialogService,
    private orderService: OrderService,
    private todayCountsService: TodayCountsService,
    private quickStatsFilterService: QuickStatsFilterService,
    private authService: AuthServiceService,
    private toastr: ToastrService, private toast: ToastService,
    private websocketService: WebsocketService,
    private websocketRefresh: WebsocketRefreshService, private dialog: MatDialog,
    public ShareddtaServices: ShareddtaService, private navigationService: NavigationserviceService,
    private breadcrumbService: BreadcrumbService
  ) { }

  ngOnInit(): void {
    this.breadcrumbService.set([]); // Clear breadcrumbs on dashboard
    localStorage.setItem('recivingorderdetail', 'false')
    this.isReturningFromDetail = localStorage.getItem('fromOrderDetail') === 'true';
    this.isSyncingReturnFlow = this.isReturningFromDetail;

    // Clear fromOrderDetail immediately after reading it
    // so search/filter works right away without waiting for background sync
    if (this.isReturningFromDetail) {
      localStorage.removeItem('fromOrderDetail');
    }

    // On hard refresh (not returning from detail), clear stale cache and filters
    if (!this.isReturningFromDetail) {
      localStorage.removeItem('ordersCache');
      localStorage.removeItem('arkiveOrdersCache');
      localStorage.removeItem('updatedOrder');
      localStorage.removeItem('cachedPage');
      localStorage.removeItem('orderListScroll');
      localStorage.removeItem('cachedTotalCount');
      localStorage.removeItem('orderListFilters');
      localStorage.removeItem('nextPageUrl');
      this.currentPage = 0; // always start from page 1 on hard refresh
    }

    this.restoreOrderListFiltersFromLocalStorage();
    this.websocketService.connect()
    this.websocketRefresh.connect();
    const cacheRestored = this.restoreOrdersFromCache();
    if (this.isReturningFromDetail && !cacheRestored) {
      // 🚀 Fallback: If cache is empty/absent, fetch via HTTP immediately
      this.fetchOrders(true);
    }
    this.restoreSelectionFromLocalStorage(); // 🔹 Restore Set from storage
    this.initializeOrderList();
    this.getDriversForReassign();
    this.setupRefreshSubscription(); // 🔹 Centralized WebSocket listener
    this.listenOrderSocket();

    // 🔹 BACKGROUND SYNC: Reconcile cache with server for return flow
    if (this.isReturningFromDetail) {
      setTimeout(() => this.triggerBulkRefresh(), 100);

      // 🛡️ EMERGENCY UNLOCK: If WebSocket or Bulk Sync hangs, unlock UI after 4 seconds
      // to ensure the user can at least use standard pagination/scrolling.
      setTimeout(() => {
        if (this.isSyncingReturnFlow) {
          console.warn('OrderSync: Emergency Unlock triggered (Sync took too long)');
          this.isSyncingReturnFlow = false;
          this.isReturningFromDetail = false;
          this.isLoading = false;
          if (this.orders.length === 0) {
            this.fetchOrders(true);
          }
        }
      }, 4000);
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    if (this.subscriptionorderlisting) this.subscriptionorderlisting.unsubscribe();
    if (this.subscriptionRefresh) this.subscriptionRefresh.unsubscribe();
    if (this.loadingSubscription) this.loadingSubscription.unsubscribe();
  }
  subscriptionorderlisting!: Subscription;
  subscriptionRefresh!: Subscription;
  loadingSubscription!: Subscription;
  lastProcessedOrderId: any;
  listenOrderSocket() {

    this.subscriptionorderlisting =
      this.ShareddtaServices.data$.subscribe((incomingDataJson: string) => {
        try {

          // 🔹 Tumhara EXACT code yahin paste hoga
          // (maine structure thoda safe bana diya hai)

          // 🔹 Parse incoming JSON
          const incomingData = JSON.parse(incomingDataJson);

          // -------------------------
          // 🔹 CASE 1: ETA / STATUS UPDATE
          // -------------------------
          if (incomingData && this.orders) {

            const indexToUpdate = this.orders.findIndex(
              (item: any) => item.id === incomingData.id
            );

            if (indexToUpdate !== -1 && incomingData.refresh === false) {

              this.orders[indexToUpdate].eta = this.orders[indexToUpdate].eta || [{}];
              this.orders[indexToUpdate].eta[0] = this.orders[indexToUpdate].eta[0] || {};

              this.orders[indexToUpdate].eta[0].etda =
                incomingData?.eta?.[0]?.etda;

              this.orders[indexToUpdate].order_status =
                incomingData?.order_status;
              // this.triggerOrderCountDebounce();
              localStorage.setItem('ordersCache', JSON.stringify(this.orders));
            }

            // -------------------------
            // 🔹 CASE 2: FULL REFRESH (PAGINATED)
            // -------------------------
            else if (incomingData.refresh === true && incomingData.action === 'order_list') {
              if (this.isProcessingDrop) {
                console.log('OrderSync: Skipping listenOrderSocket refresh because onDrop is in progress.');
                return;
              }
              if (this.getCurrentUrl.includes('/dashboard') || this.getCurrentUrl.includes('/orders')) {
                setTimeout(() => this.triggerBulkRefresh(), 300);
              }
            }

            // -------------------------
            // 🔹 CASE 3: NEW ORDER
            // -------------------------
            else if (incomingData.refresh === true &&
              incomingData.action === 'new_order') {

              if (this.getCurrentUrl.includes('/dashboard') ||
                this.getCurrentUrl.includes('/orders')) {

                setTimeout(() => {
                  this.websocketRefresh.sendOrderListRequestpending({
                    page: this.currentPage,
                    page_size: 20,
                    orderid: incomingData.id,
                    search_text: this.searchtext,
                    order_date: this.orderDate,
                    order_status: this.selectedStatuses,
                    order_type: this.orderType,
                    driver_ids: this.driverId
                  });
                }, 300);

                this.subscriptionRefresh =
                  this.ShareddtaServices.refreshdata1$.subscribe((data: any) => {
                    const IncomingData = (data);
                    const item = IncomingData.result.results;
                    const position = IncomingData.result.position;
                    this.totalOrders = IncomingData.result.count;
                    const orderId = IncomingData.result.order_id;
                    if (this.lastProcessedOrderId === orderId) {
                      console.log("Duplicate WS response ignored:", orderId);
                      return;
                    }
                    this.lastProcessedOrderId = orderId;
                    if (position >= 0 && position <= (this.currentPage + 1) * 20) {
                      const pos = position - 1;
                      this.orders.splice(pos, 0, item);
                      this.syncItemSelection(this.orders[pos]); // 🔹 Sync specific item
                    }

                    this.totalOrders = data.result.count || 0;
                    this.triggerOrderCountDebounce();
                    localStorage.setItem('ordersCache', JSON.stringify(this.orders));
                    const nextPageUrl = localStorage.getItem("nextPageUrl");

                    // -----------------------------
                    // 🔥 Case: nextPageUrl == null
                    // -----------------------------
                    if (nextPageUrl == 'null' && position > (this.currentPage + 1) * 20) {

                      // 1️⃣ org_domain fetch from localStorage
                      let orgDomain = localStorage.getItem("org_domain");
                      // example: "http://techlandspace.smilewithsangeeta.com"

                      if (!orgDomain) return; // safety

                      // 2️⃣ Remove trailing slash if exists
                      if (orgDomain.endsWith("/")) {
                        orgDomain = orgDomain.slice(0, -1);
                      }

                      // 3️⃣ Hard-coded route + dynamic page
                      const nextPage = this.currentPage + 2;

                      // 4️⃣ Final dynamic URL
                      this.nextPageUrl = `${orgDomain}/company/order-listing/?page=${nextPage}`;

                      // 5️⃣ Save in localStorage
                      localStorage.setItem("nextPageUrl", this.nextPageUrl);
                    }
                  });
              }
            }

          }

        } catch (error) {
          console.error('Error parsing incoming JSON data:', error);
        }
      });
  }
  private orderCountTimeout: any;

  triggerOrderCountDebounce() {
    if (this.orderCountTimeout) {
      clearTimeout(this.orderCountTimeout);
    }

    this.orderCountTimeout = setTimeout(() => {
      this.fetchOrderCounts();
    }, 1200);
  }

  /**
   * Initialize order list - Setup subscriptions and fetch initial data
   */
  nextPageUrl: string | null = null;
  private destroy$ = new Subject<void>();
  private initializeOrderList(): void {

    // Subscribe to loading state from service
    let firstLoadStarted = false;
    this.orderService.getLoading().pipe(skip(1)).subscribe(loading => {
      this.isLoading = loading;
      if (loading) firstLoadStarted = true;
      if (firstLoadStarted && !loading) {
        this.ShareddtaServices.signalPageReady();
      }
    });

    // Subscribe to order data
    if (this.getPreviousUrl.includes('/order-detail') || this.getPreviousUrl.includes('/order-detail')) {

    }
    this.orderService.getOrderData().subscribe(data => {
      if (!data) return;

      const newOrders = data.result?.results || [];

      this.syncOrdersSelection(newOrders);

      const fromOrderDetail = this.isReturningFromDetail;

      // 🔒 INDUSTRY STANDARD: If we are in Sync Return Flow, IGNORE standard 
      // single-page HTTP data. We want the Bulk Sync to be the source of truth.
      // BUT if we don't have any cached/loaded orders yet, use this standard HTTP result as a fallback
      // so the screen doesn't freeze in a shimmering load.
      if (this.isSyncingReturnFlow && this.orders && this.orders.length > 0) {
        console.log('OrderSync: Sync Flow Active - Dropping standard HTTP result.');
        return;
      }

      // 🔹 UNIFIED DATA HANDLER
      const isReset = (this as any)._isFetchingReset || (fromOrderDetail ? false : this.currentPage === 0);

      // If reset and we were on a deep page, scroll back to top for Page 1 visibility
      if (isReset && !fromOrderDetail) {
        this.resetScrollToTop();
      }

      this.processedOrders(newOrders, fromOrderDetail ? 0 : this.currentPage, true, isReset);
      (this as any)._isFetchingReset = false; // Reset flag

      this.allOrders = [...this.orders];

      if (!fromOrderDetail || this.orders.length === 0) {
        // 🔹 STEP 3 — Update filter counts
        if (data.result?.count !== undefined) {
          this.totalOrders = data.result.count;
        }
        // ✅ Normal case → allow cache saving
        this.nextPageUrl = data.result?.next || null;
        localStorage.setItem('nextPageUrl', JSON.stringify(this.nextPageUrl));
      } else {
        // ❌ Coming from detail → Synchronize state
        if (data.result?.count !== undefined) {
          this.totalOrders = data.result.count;
          this.totalOrderscount = data.result.count;
        }


        // 🔹 Targeted Window Sync (Atomic)
        if (this.isSyncingReturnFlow) {
          console.log('OrderSync: Atomic Return Flow started. Locking pagination.');
          this.triggerBulkRefresh();

          // Note: isSyncingReturnFlow will be set to false INSIDE processedOrders
          // when the bulk data arrives, ensuring a data-driven unlock.
          localStorage.removeItem('fromOrderDetail');
          this.isReturningFromDetail = false; // allow search/filter to work after sync
        }
        // ❌ Coming from detail → skip cache save ONCE
        console.log('Skip cache save because returned from order detail');
      }


      // 🔹 STEP 5 — Recalculate selection & bulk bar
      this.updateSelectionCount();
    });

    // 🔹 RECOVERY GUARD: Listen to global loading state to reset pagination guard
    // This ensures that even on API errors, the user isn't stuck unable to scroll.
    this.loadingSubscription = this.orderService.getLoading().subscribe(loading => {
      if (!loading) {
        this.loadingNextPage = false;

        // Safety: If we've been loading for a while but still in sync flow, 
        // we might be stuck. processedOrders normally handles this, but this is a fallback.
        if (this.isSyncingReturnFlow && !this.isLoading) {
          // We only unlock if the standard fetch also finished
        }
      }
    });




    // Subscribe to count loading state
    this.orderService.getCountLoading().subscribe(loading => {
      // Handle count loading if needed
    });

    // Subscribe to count data
    this.orderService.getOrderCount().subscribe(data => {
      if (data && data.result && data.result.all) {

        const allStatuses = data.result.all;

        // Total orders (sab counts ka sum)


        // Har status ka count nikal lo
        this.pendingCount = this.getStatusCount(allStatuses, 'pending');
        this.successfulCount = this.getStatusCount(allStatuses, 'successful');
        this.unsuccessfulCount = this.getStatusCount(allStatuses, 'unsuccessful');
        this.cancelledCount = this.getStatusCount(allStatuses, 'cancelled');
        this.enRouteCount = this.getStatusCount(allStatuses, 'en-route');
        this.shippedCount = this.getStatusCount(allStatuses, 'shipped');
        this.arrivedCount = this.getStatusCount(allStatuses, 'arrived');
        this.warehouseCount = this.getStatusCount(allStatuses, 'warehouse');
        const todayList = data.result.today;
        this.todayDelivery = this.getTypeCount(todayList, 'delivery');
        this.todayPickup = this.getTypeCount(todayList, 'pickup');
        this.todayTotalDP = this.todayDelivery + this.todayPickup;
        this.active_driver_count = data.result.active_driver_count || 0;
        console.log('Active Driver Count:', this.active_driver_count);

        // Update counts in service for header to display
        this.todayCountsService.updateTodayCounts(this.todayDelivery, this.todayPickup, this.active_driver_count);
        this.totalOrderscount = this.pendingCount + this.successfulCount + this.unsuccessfulCount + this.cancelledCount + this.enRouteCount + this.shippedCount + this.arrivedCount + this.warehouseCount;
        // Emit today's counts to header component
        this.todayCountsUpdated.emit({
          delivery: this.todayDelivery,
          pickup: this.todayPickup,
          total: this.todayTotalDP,
          active_driver_count: this.active_driver_count,
        });
      }
    });

    this.quickStatsFilterService.quickStatsFilter$
      .pipe(
        debounceTime(350), // 🔹 reduce debounce for snappy feel
        distinctUntilChanged((prev, curr) => JSON.stringify(prev) === JSON.stringify(curr)), takeUntil(this.destroy$)
      )
      .subscribe(filter => {
        // 🔹 GUARD: Only ignore if the filter is explicitly null (initial service state)
        // and we already have a restored value.
        if (filter.searchtext === null && this.searchtext !== undefined) {
          console.log('OrderSync: Skipping initial null filter (preserving restored search)');
          return;
        }

        let changed = false;

        // 🔥 Sirf jab real change ho tabhi mark karo
        if (filter.orderDate !== undefined && filter.orderDate !== this.orderDate) {
          if (filter.orderDate != null) {
            this.orderDate = this.orderDate || filter.orderDate;
            changed = true;
          }
          if (filter.orderDate === null) {
            this.orderDate = filter.orderDate;
            changed = true;
          }
        }

        if (filter.orderType !== undefined) {
          const newType = filter.orderType === 'todayOrders' ? null : filter.orderType;
          if (newType !== this.orderType) {
            this.orderType = newType;
            changed = true;
          }
        }

        if (filter.searchtext !== undefined && filter.searchtext !== this.searchtext) {
          this.searchtext = filter.searchtext;
          changed = true;
        }

        // Force 'changed' if this is an initialized state where we have an active filter 
        // that must override default loaded list
        if (filter.orderType !== undefined) {
          changed = true;
        }

        // ❌ Guard: Skip if we are on the receiving side (URL check)
        if (this.router.url.includes('/receiving-admin')) {
          console.log('Skipping Shipping Filter reaction (on Receiving page)');
          return;
        }

        // ❌ Remove caching guard here. If a filter is clicked, we WANT fresh API data.
        // Cache is only for initial load before user interaction.

        // ❌ Guard: Skip if we are returning from detail (initial component load)
        if (this.isReturningFromDetail) {
          console.log('Returning from detail → skipping filter-triggered reset/fetch');
          // No need to fetchOrders here; ngOnInit handles the cache restoration and background sync.
          return;
        }

        // 🔹 Ab hi reset + reload
        console.log('Real filter changed → reload list');

        this.currentPage = 0;
        localStorage.setItem('isSearchApplied', 'false');

        // 🔥 PERSIST: Save the new type/date/search to localStorage so it survives detail-view navigation
        this.saveOrderListFiltersToLocalStorage();

        // 🔹 fresh API (RESET MODE)
        this.fetchOrders(true);
        this.fetchOrderCounts();
      });
  }

  getStatusCount(list: any[], status: string): number {
    const found = list.find(item => item.order_status === status);
    return found ? found.count : 0;
  }
  getTypeCount(list: any[], type: string): number {
    const found = list.find(item => item.order_type === type);
    return found ? found.count : 0;
  }

  ngAfterViewInit(): void {
    // 🔹 ATOMIC SCROLL RESTORATION (Only when returning from detail)
    if (!this.isReturningFromDetail) return;

    const savedScroll = localStorage.getItem('orderListScroll');
    if (savedScroll && this.tableContainer) {
      const scrollPos = parseInt(savedScroll, 10);
      this.isRestoringScroll = true; // 🔒 LOCK ON

      // ⚡️ IMMEDIATELY recalculate range before timeout for instant visual feedback
      this.updateVisibleRange(scrollPos);

      // Attempt multiple times to ensure DOM is settled
      const restorationDelays = [50, 150, 300, 600];
      restorationDelays.forEach((delay, index) => {
        setTimeout(() => {
          if (this.tableContainer) {
            this.tableContainer.nativeElement.scrollTop = scrollPos;
            // Also update range here to ensure accuracy as content renders
            this.updateVisibleRange(scrollPos);
          }
          // Unlock on the last attempt (with an extra safety buffer)
          if (index === restorationDelays.length - 1) {
            setTimeout(() => {
              this.isRestoringScroll = false; // 🔓 LOCK OFF after cooling period
            }, 1000);
          }
        }, delay);
      });
    }
  }


  /**
   * Fetch orders from API with current filters
   */
  private fetchOrders(isReset: boolean = false): void {
    const page = this.currentPage; // API expects 0-based index
    (this as any)._isFetchingReset = isReset; // Temporary flag for subscribe
    this.orderService.orderList(
      this.searchtext,  // search_text
      this.orderDate,  // order_date
      this.currentFilter === 'all' ? null : this.currentFilter,  // order_status
      this.orderType,  // order_type
      this.driverId,  // driver_id
      page   // page
    );
  }

  /**
   * 🔹 RESET SCROLL: Moves table container back to top for fresh context
   */
  private resetScrollToTop(): void {
    if (this.tableContainer) {
      this.tableContainer.nativeElement.scrollTop = 0;
      localStorage.removeItem('orderListScroll');
    }
  }

  /**
   * Fetch order counts for filters
   */
  private fetchOrderCounts(): void {
    let date = new Date();
    let formatDate =
      date.getFullYear() + '-' +
      String(date.getMonth() + 1).padStart(2, '0') + '-' +
      String(date.getDate()).padStart(2, '0');
    this.todaysDate = formatDate;
    this.orderService.orderCount(
      this.orderDate,  // order_date
      this.orderType,  // order_type
      this.driverId,  // driver_id
      this.currentFilter === 'all' ? null : this.currentFilter,  // order_status
      this.todaysDate,  // today_date
      this.searchtext,  // search_text
      null,  // ispending
    );
  }

  /**
   * Load mock orders data (60 orders)
   */
  loadOrders(): void {
    const customers = [
      { name: 'Gucci / Jeevan', company: 'Lexicor' },
      { name: 'Receiving Dept', company: 'Spiral Master' },
      { name: 'Rob', company: 'Metro Insulation' },
      { name: 'Sarah Johnson', company: 'Tech Solutions Inc' },
      { name: 'Michael Chen', company: 'Global Logistics' },
      { name: 'Emma Wilson', company: 'FastTrack Shipping' },
      { name: 'John Smith', company: 'Acme Corporation' },
      { name: 'Lisa Anderson', company: 'Prime Delivery' },
      { name: 'David Brown', company: 'Express Services' },
      { name: 'Maria Garcia', company: 'QuickShip Inc' }
    ];

    const addresses = [
      '151 City Centre Drive, Mississauga, ON, Canada',
      '6611 Innovator Drive, Mississauga, ON, Canada',
      '315 Spadina Avenue, Toronto, ON, Canada',
      '2500 University Drive, Calgary, AB, Canada',
      '890 Yonge Street, Toronto, ON, Canada',
      '1234 Main Street, Vancouver, BC, Canada',
      '5678 Oak Avenue, Montreal, QC, Canada',
      '9012 Pine Road, Ottawa, ON, Canada'
    ];

    const drivers = ['TR', 'AM', 'JK', 'MB', 'SD', 'PK'];
    const driverName = ['Tony Rao', 'Ammey Jackson', 'Shubham Pandey', 'Aviansh Singh', 'Satyam Pandey', 'Pawan Singh'];
    const driverFullName =
      driverName[Math.floor(Math.random() * driverName.length)];
    const statuses: Array<'pending' | 'successful' | 'unsuccessful' | 'cancelled'> = ['pending', 'pending', 'pending', 'successful', 'unsuccessful'];

    // Generate 60 orders
    for (let i = 1; i <= 60; i++) {
      const customer = customers[Math.floor(Math.random() * customers.length)];
      const address = addresses[Math.floor(Math.random() * addresses.length)];
      const driver = drivers[Math.floor(Math.random() * drivers.length)];
      const driverFullName = driverName[Math.floor(Math.random() * driverName.length)];
      const status = statuses[Math.floor(Math.random() * statuses.length)];
      const hour = 1 + Math.floor(Math.random() * 11);
      const minute = Math.floor(Math.random() * 60);
      const ampm = Math.random() > 0.5 ? 'AM' : 'PM';
      const isPickup = Math.random() < 0.3;
      this.allOrders.push({
        id: `order-${6248900 + i}`,
        orderId: `${123400 + i}`,
        orderIcon: isPickup ? 'P' : 'D',
        orderType: isPickup ? 'pickup' : 'delivery',
        customerName: customer.name,
        customerCompany: customer.company,
        address: address,
        deliveryDate: 'Fri Dec 12 2025',
        committedTime: `${hour.toString().padStart(2, '0')}:00 ${ampm}`,
        deliveryTime: `${hour}:${minute.toString().padStart(2, '0')} ${ampm}`,
        driverInitials: driver,
        driverName: this.formatDriverName(driverFullName),
        status: status,
        eta: `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')} ${ampm}`,
        selected: false
      });
    }

    this.orders = [...this.allOrders];
  }
  formatDriverName(fullName: string): string {
    const parts = fullName.trim().split(' ');

    if (parts.length === 1) {
      return parts[0];
    }

    const isVirtual = parts.some(p => p.toLowerCase().includes('truck') || p.toLowerCase().includes('zone'));
    const hasNumbers = /\d/.test(fullName);

    if (isVirtual || hasNumbers) {
      return fullName;
    }

    const firstName = parts[0];
    const initials = parts.slice(1).map(p => p.charAt(0).toUpperCase());

    return `${firstName} ${initials.join(' ')}`;
  }

  /**
   * Check if an element's text is truncated (overflowing)
   */
  isTruncated(element: HTMLElement): boolean {
    return element.scrollWidth > element.offsetWidth;
  }

  hasValidDriver(order: any): boolean {
    if (!order?.current_driver?.id) return false;
    if (order.current_driver.is_virtual_user === true && order.current_driver.is_deleted === true) return false;
    return true;
  }

  loadingNextPage = false;

  onTableScroll(event: any): void {
    // 🔒 INDUSTRY STANDARD: Drop all scroll events during restoration or sync
    if (this.isRestoringScroll || this.isSyncingReturnFlow) return;

    const scrollTop = event.target.scrollTop;
    const scrollHeight = event.target.scrollHeight;
    const clientHeight = event.target.clientHeight;

    const scrollDirection = scrollTop > (this.lastScrollTop || 0) ? 'down' : 'up';
    this.lastScrollTop = scrollTop;

    if (
      scrollDirection === 'down' &&
      this.nextPageUrl &&
      this.nextPageUrl !== 'null' &&
      this.nextPageUrl !== '' &&
      scrollHeight - (scrollTop + clientHeight) <= 100 &&
      !this.loadingNextPage
    ) {
      this.loadNextPage();
    }

    // 🔹 Recalculate Range and Progress
    this.updateVisibleRange(scrollTop);

    // 🔹 PERSIST STATE
    localStorage.setItem('orderListScroll', scrollTop.toString());
    localStorage.setItem('cachedTotalCount', this.totalOrders?.toString());
    localStorage.setItem('cachedPage', this.currentPage.toString());
  }

  /**
   * 🔹 Dynamic Range Calculation & Progress Tracking
   */
  private updateVisibleRange(scrollTop: number): void {
    if (!this.tableContainer) return;

    const element = this.tableContainer.nativeElement;
    const scrollHeight = element.scrollHeight;
    const clientHeight = element.clientHeight;

    const rowHeight = 62;
    const pageSize = 20;
    const total = this.totalOrders || this.orders.length;

    // Determine which "page block" we are currently viewing
    let firstVisibleIndex = Math.floor(scrollTop / rowHeight);

    // 🔹 Strict Cap: never let the index exceed the total number of orders
    firstVisibleIndex = Math.min(firstVisibleIndex, Math.max(0, total - 1));

    const currentPageIndex = Math.floor(firstVisibleIndex / pageSize);

    this.visibleRangeStart = (currentPageIndex * pageSize) + 1;
    this.visibleRangeEnd = Math.min((currentPageIndex + 1) * pageSize, total);

    // Safety check for empty or small lists
    if (total === 0) {
      this.visibleRangeStart = 1;
      this.visibleRangeEnd = 0;
    }

    // 🔹 Progress Bar Calculation
    const totalScrollableHeight = scrollHeight - clientHeight;
    this.scrollProgress = totalScrollableHeight > 0 ? (scrollTop / totalScrollableHeight) * 100 : 0;
  }
  loadNextPage(): void {
    // 🔒 Hard Guard: Prevent pagination during state synchronization
    if (!this.nextPageUrl || this.loadingNextPage || this.isRestoringScroll || this.isReturningFromDetail || this.isSyncingReturnFlow) return;

    this.loadingNextPage = true;

    const match = this.nextPageUrl.match(/page=(\d+)/);
    const nextPage = match && match[1] ? Number(match[1]) : this.currentPage + 1;

    this.currentPage = nextPage - 1;

    this.orderService.orderList(
      this.searchtext,  // search_text
      this.orderDate,  // order_date
      this.currentFilter === 'all' ? null : this.currentFilter,  // order_status
      this.orderType,  // order_type
      this.driverId,
      this.currentPage
    );

    // service subscription will update `orders` automatically
    // The `loadingNextPage` flag should be reset within the subscription's success callback
    // to ensure it's only reset when data is actually received.
    // For now, removing the timeout as per instruction, assuming the service handles the reset.
  }

  onStatusChange(event: any): void {
    const value = event.target.value;
    const checked = event.target.checked;

    if (checked) {

      // agar all hai aur koi aur select ho raha hai → all hata do
      if (value !== 'all' && this.selectedStatuses.includes('all')) {
        this.selectedStatuses = this.selectedStatuses.filter(s => s !== 'all');
      }

      if (!this.selectedStatuses.includes(value)) {
        this.selectedStatuses.push(value);
      }

    } else {
      // remove
      this.selectedStatuses = this.selectedStatuses.filter(s => s !== value);
    }
    this.saveOrderListFiltersToLocalStorage();
    this.applyFilters();
  }


  applyFilters(): void {
    this.orders = [];
    this.currentPage = 0;


    if (this.selectedStatuses.length > 0) {
      // pending,successful,cancelled
      this.currentFilter = this.selectedStatuses.join(',');
    } else {
      // agar kuch bhi select nahi hai to all
      this.currentFilter = 'all';
    }
    this.fetchOrders();
    this.fetchOrderCounts();
  }
  /**
   * Change status filter
   */
  setFilter(filter: string): void {

    // Chips se click aaya hai → dropdown ko bhi sync karo
    if (filter === 'all') {
      // sab clear
      this.selectedStatuses = [];
      this.currentFilter = 'all';
    } else {
      // single select
      this.selectedStatuses = [filter];
      this.currentFilter = filter;
    }

    this.orders = [];
    this.currentPage = 0;
    this.saveOrderListFiltersToLocalStorage();
    this.fetchOrders();
    this.fetchOrderCounts();
  }

  setFilterDateWise(filter: string): void {
    this.orderDate = this.todaysDate;
    this.setFilter(filter);
  }

  setDatefilter(): void {
    this.orders = [];
    this.currentPage = 0;
    this.saveOrderListFiltersToLocalStorage();
    this.fetchOrders();
    this.fetchOrderCounts();
  }

  /**
   * Toggle advanced filters panel
   */
  toggleAdvancedFilters(): void {
    this.showAdvancedFilters = !this.showAdvancedFilters;
  }

  /**
   * Apply advanced filters
   */
  applyAdvancedFilters(): void {
    this.currentPage = 0;
    this.fetchOrders();
    this.fetchOrderCounts();
    this.showAdvancedFilters = false;
  }

  /**
   * Reset advanced filters
   */
  resetAdvancedFilters(): void {
    this.advancedFilters = {
      customerName: '',
      company: '',
      driver: '',
      city: '',
      dateFrom: '',
      dateTo: ''
    };
    this.currentPage = 0;
    this.fetchOrders();
    this.fetchOrderCounts();
  }

  /**
   * Clear all filters
   */
  clearFilters(): void {
    this.orders = [];
    localStorage.setItem('ordersCache', JSON.stringify(this.orders));
    this.currentFilter = 'all';
    this.orderDate = null;
    this.orderType = null;
    this.driverId = null;
    this.searchtext = null;
    this.advancedFilters = {
      customerName: '',
      company: '',
      driver: '',
      city: '',
      dateFrom: '',
      dateTo: ''
    };
    this.selectedDrivers = [];
    this.selectedStatuses = [];
    this.currentPage = 0;
    // Deselect all quick stats tabs in header
    this.quickStatsFilterService.updateQuickStatsFilter(null, null, null, null);
    this.selectedOrderIds.clear();        // global selection memory clear
    this.deselectedOrderIds.clear();
    this.orders.forEach((o: { selected: boolean; }) => o.selected = false); // current UI clear
    this.updateSelectionCount();
    this.groupSelectionActive = false;
    this.activeGroupDriverId = null;
    this.activeGroupStatus = null;
    localStorage.removeItem('orderHeaderActiveTab');
    localStorage.removeItem('orderHeaderSearch');
    this.removeOrderListFiltersFromLocalStorage();
    this.nextPageUrl = localStorage.getItem('nextPageUrl');
    // aur bhi filter ho toh yahan restore karein
    this.fetchOrders();
    this.fetchOrderCounts();
  }

  /**
   * Toggle order selection
   */
  toggleOrderSelection(order: any): void {
    order.selected = !order.selected;
    
    // 🔹 Break the group selection lock if a user manually deselects an order
    if (!order.selected) {
      this.groupSelectionActive = false;
      this.activeGroupDriverId = null;
      this.activeGroupStatus = null;
      this.activeGroupDate = null;
    }

    // Let updateSelectionCount handle the Set synchronization
    this.updateSelectionCount();
  }

  /**
   * Select all orders
   */
  selectAll(event: any): void {
    const checked = event.target.checked;
    this.orders.forEach((order: any) => {
      order.selected = checked;
    });
    this.updateSelectionCount();
  }

  /**
   * Clear selection
   */
  clearSelection(): void {
    this.selectedOrderIds.clear(); // 🔹 Clear the global source of truth
    this.deselectedOrderIds.clear();
    this.orders.forEach((order: any) => order.selected = false);
    
    // 🔹 Clear group selection lock
    this.groupSelectionActive = false;
    this.activeGroupDriverId = null;
    this.activeGroupStatus = null;
    this.activeGroupDate = null;

    this.updateSelectionCount();
  }

  /**
   * Update selection count
   */
  // updateSelectionCount(): void {
  //   this.selectedCount = this.orders.filter((o: { selected: any; }) => o.selected).length;
  //   this.showBulkActions = this.selectedCount > 0;
  // }
  selectedOrderIds: Set<string> = new Set();
  deselectedOrderIds: Set<string> = new Set();

  updateSelectionCount(): void {
    // 🔹 1. Sync current page objects to the Set (source of truth)
    this.orders.forEach((o: any) => {
      const idStr = o.id.toString();
      if (o.selected) {
        this.selectedOrderIds.add(idStr);
        this.deselectedOrderIds.delete(idStr);
      } else {
        if (this.selectedOrderIds.has(idStr)) {
          this.selectedOrderIds.delete(idStr);
          this.deselectedOrderIds.add(idStr);
        }
      }
    });

    // 🔹 2. Selection count reflects the TOTAL unique IDs selected across all pages
    this.selectedCount = this.selectedOrderIds.size;
    this.showBulkActions = this.selectedCount > 0;
    this.saveSelectionToLocalStorage(); // 🔹 Save state change
  }

  saveSelectionToLocalStorage(): void {
    localStorage.setItem('selectedOrderIds', JSON.stringify(Array.from(this.selectedOrderIds)));
  }

  restoreSelectionFromLocalStorage(): void {
    const saved = localStorage.getItem('selectedOrderIds');
    if (saved) {
      const ids = JSON.parse(saved).map((id: any) => id.toString());
      this.selectedOrderIds = new Set(ids);
      this.syncOrdersSelection(); // Apply to currently loaded orders
      this.updateSelectionCount(); // 🔹 Ensure bottom bar appears immediately
    }
  }

  /**
   * 🔹 Helper to sync a single order item's selection status
   */
  syncItemSelection(order: any): void {
    if (!order) return;
    const idStr = order.id.toString();
    if (this.deselectedOrderIds.has(idStr)) {
      order.selected = false;
    } else if (this.selectedOrderIds.has(idStr)) {
      order.selected = true;
    } else if (
      this.groupSelectionActive &&
      order.current_driver?.id === this.activeGroupDriverId &&
      order.order_status === this.activeGroupStatus &&
      (!this.activeGroupDate || this.convertToLocalDate(order.dely_date) === this.activeGroupDate)
    ) {
      order.selected = true;
      this.selectedOrderIds.add(idStr);
    } else {
      order.selected = false;
    }
  }

  /**
   * 🔹 Helper to sync a whole list of orders or this.orders
   */
  syncOrdersSelection(list?: any[]): void {
    const target = list || this.orders;
    if (!target) return;
    target.forEach((order: any) => this.syncItemSelection(order));
  }
  // toggleRowSelection(clickedOrder: any) {

  //   const targetDriverId = clickedOrder.current_driver.id;
  //   const targetStatus  = clickedOrder.order_status;

  //   // 🔹 Decide: select group or unselect group (toggle logic)
  //   const shouldSelect = !clickedOrder.selected;

  //   // 🔹 Loop through all currently loaded orders
  //   this.orders.forEach((order: any) => {

  //     // Match condition → same driver + same status
  //     if (
  //       order.current_driver.id === targetDriverId &&
  //       order.order_status === targetStatus
  //     ) {
  //       order.selected = shouldSelect;   // select OR unselect whole group
  //     }

  //   });

  //   // 🔹 Sync count, bulk bar, global memory (existing logic)
  //   this.updateSelectionCount();
  // }
  toggleRowSelection(clickedOrder: any, forceSelect?: boolean) {
    // Cancel any pending navigation (not used anymore, kept for safety)
    if ((this as any).clickTimer) {
      clearTimeout((this as any).clickTimer);
      (this as any).clickTimer = null;
    }

    const targetDriverId = clickedOrder.current_driver?.id;
    const targetStatus = clickedOrder.order_status;
    const isUnassigned = !targetDriverId;
    const targetDateStr = this.convertToLocalDate(clickedOrder.dely_date);
    const isZoneOrder = clickedOrder.current_driver?.is_virtual_user === true &&
      !clickedOrder.current_driver?.first_name?.toLowerCase().includes('truck');

    // Build the matching predicate
    const isMatch = (order: any): boolean => {
      const orderDriverId = order.current_driver?.id;
      const orderDateStr = this.convertToLocalDate(order.dely_date);
      const isStatusMatch = order.order_status === targetStatus;

      // 🔹 Work date-wise for:
      // 1. Unassigned orders (Pending Unassigned)
      // 2. Successful / Unsuccessful / Cancelled
      // 3. Zone orders (virtual zone users)
      const needsDateCheck = isUnassigned ||
        ['successful', 'unsuccessful', 'cancelled'].includes(targetStatus.toLowerCase()) ||
        isZoneOrder;

      if (needsDateCheck) {
        return (isUnassigned ? !orderDriverId : orderDriverId === targetDriverId) &&
          isStatusMatch &&
          orderDateStr === targetDateStr;
      } else {
        return orderDriverId === targetDriverId && isStatusMatch;
      }
    };

    // Get all matching orders in the group
    const groupOrders = this.orders.filter((o: any) => isMatch(o));

    // If forceSelect is passed (checkbox dblclick), use it; otherwise toggle:
    // if ALL are already selected → deselect; otherwise → select all
    let shouldSelect: boolean;
    if (forceSelect !== undefined) {
      shouldSelect = forceSelect;
    } else {
      const allSelected = groupOrders.every((o: any) => o.selected);
      shouldSelect = !allSelected;
    }

    // 🔹 Save / clear active group
    if (shouldSelect) {
      this.activeGroupDriverId = targetDriverId;
      this.activeGroupStatus = targetStatus;
      this.activeGroupDate = (isUnassigned || ['successful', 'unsuccessful', 'cancelled'].includes(targetStatus.toLowerCase()) || isZoneOrder) ? targetDateStr : null;
      this.groupSelectionActive = true;
    } else {
      this.activeGroupDriverId = null;
      this.activeGroupStatus = null;
      this.activeGroupDate = null;
      this.groupSelectionActive = false;
    }

    // 🔹 Apply selection to all matching orders
    groupOrders.forEach((order: any) => {
      order.selected = shouldSelect;
      const idStr = order.id.toString();
      if (shouldSelect) {
        this.deselectedOrderIds.delete(idStr);
      } else {
        this.deselectedOrderIds.delete(idStr);
        this.selectedOrderIds.delete(idStr);
      }
    });

    this.updateSelectionCount();
  }

  onCheckboxDblClick(event: MouseEvent, order: any): void {
    event.stopPropagation();
    // Use the same group toggle logic as row dblclick (no forceSelect)
    this.toggleRowSelection(order);
  }




  /**
   * Toggle action dropdown
   */
  dropdownPosition: any = {};

  toggleDropdown(event: MouseEvent, orderId: string): void {

    if (this.activeDropdown === orderId) {
      this.activeDropdown = null;
      return;
    }

    const button = event.target as HTMLElement;
    const rect = button.getBoundingClientRect();

    this.dropdownPosition = {
      top: rect.bottom + window.scrollY + 'px',
    };

    this.activeDropdown = orderId;
  }


  /**
   * Close all dropdowns
   */
  closeAllDropdowns(): void {
    this.activeDropdown = null;
    this.showDriverFilter = false;
    this.showStatusFilter = false;
  }

  toggleDriverFilter() {
    this.showDriverFilter = !this.showDriverFilter;
    if (this.showDriverFilter) {
      this.getDriversForReassign();
    }
  }

  /**
   * Export orders
   */
  exportOrders(): void {
    // console.log('Exporting orders...');
    alert('Export functionality - to be implemented');
  }

  /**
   * Bulk actions
   */
  // bulkAssign(): void {
  //   console.log('Bulk assign:', this.selectedCount, 'orders');
  //   alert(`Assigning ${this.selectedCount} orders...`);
  // }
  async bulkAssign(): Promise<void> {
    const ids = this.orders
      .filter((o: any) => o.selected)
      .map((o: any) => o.id);

    if (ids.length === 0) {
      this.toast.show('warning', 'Please select at least one order');
      return;
    }

    const label = ids.length === 1 ? 'order' : 'orders';

    const dialogResult = await this.dialogService.confirm(
      'Assign Orders',
      `Are you sure you want to assign ${label}?`,
      'Assign',
      'Cancel'
    );

    if (dialogResult?.confirmed) {
      const formdata = new FormData();
      formdata.append('order_ids', JSON.stringify(ids));
      formdata.append('driver_id', dialogResult.driverId);  // ✅ yahin se aa raha hai

      this.orderService.orderAssign(formdata).subscribe(
        (data: any) => {
          if (this.authService.resultCodeError(data)) return;
          if (data.resultDescription) {
            this.toast.show('success', data.resultDescription);
          }
          this.clearSelection();
        },
        (error) => {
          this.authService.dataError(error);
        }
      );
    }
  }


  async bulkUnassign(): Promise<void> {
    // Get selected order IDs
    const ids = this.orders
      .filter((o: any) => o.selected)
      .map((o: any) => o.id);

    if (ids.length === 0) {
      this.toast.show('warning', 'Please select at least one order');
      return;
    }

    // 🔥 Singular / Plural message
    const label = ids.length === 1 ? 'order' : 'orders';

    const confirmed = await this.dialogService.confirm(
      'Unassign Orders',
      `Are you sure you want to unassign ${label}?`,
      'Unassign',
      'Cancel'
    );

    if (!confirmed?.confirmed) {
      return;
    }

    // Prepare FormData for API
    const formdata = new FormData();
    formdata.append('order_ids', JSON.stringify(ids));
    // console.log("FormData Value:", formdata.get('order_ids'));

    // API call for unassign
    this.orderService.orderunAssign(formdata).subscribe(
      (data: any) => {
        if (this.authService.resultCodeError(data)) {
          return;
        }

        // Reset selection
        this.clearSelection();
        // this.fetchOrders();
        // // Refresh counts / stats
        // this.fetchOrderCounts();

        if (data.resultDescription) {
          this.toast.show('success', data.resultDescription);
        }
      },
      (error) => {
        this.authService.dataError(error);
      }
    );
  }
  async bulkRoute(): Promise<void> {
    // Get selected order IDs
    const ids = this.orders
      .filter((o: any) => o.selected)
      .map((o: any) => o.id);

    if (ids.length === 0) {
      this.toast.show('warning', 'Please select at least one order');
      return;
    }

    // 🔥 Singular / Plural message
    const label = ids.length === 1 ? 'order' : 'orders';

    const confirmed = await this.dialogService.confirm(
      'Route Orders',
      `Are you sure you want to route ${label}?`,
      'Route',
      'Cancel'
    );

    if (!confirmed.confirmed) {
      return;
    }

    // Prepare FormData for API
    const formdata = new FormData();
    formdata.append('order_ids', JSON.stringify(ids));
    // console.log("FormData Value:", formdata.get('order_ids'));

    // API call for unassign
    this.orderService.orderRoute(formdata).subscribe(
      (data: any) => {
        if (this.authService.resultCodeError(data)) {
          return;
        }

        // Reset selection
        this.clearSelection();
        // this.fetchOrders();
        // // Refresh counts / stats
        // this.fetchOrderCounts();

        if (data.resultDescription) {
          this.toast.show('success', data.resultDescription);
        }
      },
      (error) => {
        this.authService.dataError(error);
      }
    );
  }
  async bulkRefresh(): Promise<void> {
    // Get selected order IDs
    const ids = this.orders
      .filter((o: any) => o.selected)
      .map((o: any) => o.id);

    if (ids.length === 0) {
      this.toast.show('warning', 'Please select at least one order');
      return;
    }

    // 🔹 SEQUENCE VALIDATION (Group-Aware) — disabled for now, backend handles this
    // const selectedOrders = this.orders.filter((o: any) => o.selected);
    // const expandedOrders = this.getExpandedValidationOrders(selectedOrders);
    // const outOfSequenceDrivers = this.getOutOfSequenceDrivers(expandedOrders);
    // if (outOfSequenceDrivers.length > 0) {
    //   const driverNames = outOfSequenceDrivers.join(', ');
    //   confirmMessage += `<br><br><span class="sequence-note">Note: ${driverNames} orders are not in the right sequence.</span>`;
    // }

    // 🔥 Singular / Plural message
    const label = ids.length === 1 ? 'order' : 'orders';
    let confirmMessage = `Are you sure you want to refresh the ETA?`;

    const confirmed = await this.dialogService.confirm(
      'Refresh ETA Orders',
      confirmMessage,
      'Refresh ETA',
      'Cancel'
    );

    if (!confirmed.confirmed) {
      return;
    }

    // Prepare FormData for API
    const formdata = new FormData();
    formdata.append('order_ids', JSON.stringify(ids));
    formdata.append('refresh_eta', 'true');
    // console.log("FormData Value:", formdata.get('order_ids'));

    // API call for unassign
    this.orderService.orderRoute(formdata).subscribe(
      (data: any) => {
        if (this.authService.resultCodeError(data)) {
          return;
        }

        // Reset selection
        this.clearSelection();
        // this.fetchOrders();
        // // Refresh counts / stats
        // this.fetchOrderCounts();
        if (data.resultDescription) {
          this.toast.show('success', data.resultDescription);
        }

      },
      (error) => {
        this.authService.dataError(error);
      }
    );
  }

  /**
   * 🔹 Validation: Expands selected set to include all siblings in groups
   */
  private getExpandedValidationOrders(selectedOrders: any[]): any[] {
    const expandedSet = new Set<any>();

    selectedOrders.forEach(clickedOrder => {
      const targetDriverId = clickedOrder.current_driver?.id;
      const targetStatus = clickedOrder.order_status;
      const isUnassigned = !targetDriverId;
      const targetDateStr = this.convertToLocalDate(clickedOrder.dely_date);

      const isMatch = (order: any): boolean => {
        const orderDriverId = order.current_driver?.id;
        const orderDateStr = this.convertToLocalDate(order.dely_date);
        const isStatusMatch = order.order_status === targetStatus;

        const needsDateCheck = isUnassigned || ['successful', 'unsuccessful', 'cancelled'].includes(targetStatus?.toLowerCase());

        if (needsDateCheck) {
          return (isUnassigned ? !orderDriverId : orderDriverId === targetDriverId) &&
            isStatusMatch &&
            orderDateStr === targetDateStr;
        } else {
          return orderDriverId === targetDriverId && isStatusMatch;
        }
      };

      this.orders.forEach((o: any) => {
        if (isMatch(o)) {
          expandedSet.add(o);
        }
      });
    });

    return Array.from(expandedSet);
  }

  /**
   * 🔹 Validation: Checks if priorities are strictly ascending for each driver
   * Returns array of driver names whose orders are out of sequence
   */
  private getOutOfSequenceDrivers(expandedOrders: any[]): string[] {
    const driverGroups: { [key: string]: { orders: any[], driverName: string } } = {};

    // Group orders by driver
    expandedOrders.forEach(order => {
      const driverId = order?.current_driver?.id;
      if (!driverId) return;

      if (!driverGroups[driverId]) {
        const firstName = order.current_driver.first_name || '';
        const lastName = order.current_driver.last_name || '';
        driverGroups[driverId] = {
          orders: [],
          driverName: `${firstName} ${lastName}`.trim()
        };
      }
      driverGroups[driverId].orders.push(order);
    });

    const outOfSequenceDrivers: string[] = [];

    // Check each driver's group
    for (const driverId in driverGroups) {
      const { orders, driverName } = driverGroups[driverId];

      // Sort by their position in the current table (this.orders)
      const ordersWithIndices = orders.map(order => ({
        order,
        index: this.orders.findIndex((o: any) => o.id === order.id)
      })).sort((a, b) => a.index - b.index);

      const priorities = ordersWithIndices.map(item => {
        const o = item.order;
        const p = o.order_type === 'delivery' ? o.is_dely_first_delivery : o.is_pickup_first_delivery;
        return p ? Number(p) : null;
      }).filter((p): p is number => p !== null);

      // Check if priorities are in strict ascending order
      let isSequential = true;
      for (let i = 0; i < priorities.length - 1; i++) {
        if (priorities[i] >= priorities[i + 1]) {
          isSequential = false;
          break;
        }
      }

      if (!isSequential) {
        outOfSequenceDrivers.push(driverName);
      }
    }

    return outOfSequenceDrivers;
  }

  bulkReassign(): void {
    console.log('Bulk reassign:', this.selectedCount, 'orders');
    alert(`Reassigning ${this.selectedCount
      } orders...`);
  }

  async bulkDelete(): Promise<void> {

    const ids = this.orders
      .filter((o: any) => o.selected)
      .map((o: any) => o.id);

    if (ids.length === 0) {
      this.toast.show('warning', 'Please select at least one order');
      return;
    }

    // 🔥 Singular / Plural message
    const label = ids.length === 1 ? 'order' : 'orders';

    const confirmed = await this.dialogService.confirm(
      'Delete Orders',
      `Are you sure you want to delete ${label}? This action cannot be undone.`,
      'Delete',
      'Cancel'
    );

    if (!confirmed?.confirmed) {
      return;
    }

    // API call
    const formdata = new FormData();
    formdata.append('order_ids', JSON.stringify(ids));
    // console.log("FormData Value:", formdata.get('order_ids'));

    this.orderService.orderDelete(formdata).subscribe(
      (data: any) => {
        if (this.authService.resultCodeError(data)) {
          return;
        }

        // 🔹 Instantly update local list and cache
        const deletedIdsSet = new Set(ids);
        this.orders = this.orders.filter((o: any) => !deletedIdsSet.has(o.id));
        this.allOrders = [...this.orders];
        localStorage.setItem('ordersCache', JSON.stringify(this.orders));

        // selection reset
        this.clearSelection();
        this.triggerBulkRefresh();
        this.updateSelectionCount();
        this.fetchOrderCounts();
        this.toast.show('success', data.resultDescription);
      },
      (error) => {
        this.authService.dataError(error);
      }
    );
  }

  /**
   * Order actions
   */
  viewOrder(order: Order): void {
    console.log('View order:', order.id);
    alert(`Viewing order ${order.orderId} `);
  }

  editOrder(order: any): void {
    const orderId = order?.parent_order ? order.parent_order : order.id;
    this.router.navigate(['admin/orders/edit', orderId]);
    // Implement edit functionality
  }

  // trackOrder(order: Order): void {
  //   console.log('Track order:', order.id);
  //   alert(`Tracking order ${order.orderId} `);
  // }

  // deleteOrder(order: Order): void {
  //   if (confirm(`Delete order ${ order.orderId }?`)) {
  //     this.orders = this.orders.filter(o => o.id !== order.id);
  //     this.applyFilters();
  //   }
  // }

  async deleteOrder(orderId: any): Promise<void> {
    const confirmed = await this.dialogService.confirm(
      'Delete Row',
      'Are you sure you want to delete this row? This action cannot be undone.',
      'Delete',
      'Cancel'
    );

    if (confirmed?.confirmed) {
      var formdata = new FormData();
      formdata.append('order_ids', JSON.stringify([orderId]));
      // console.log("FormData Value:", formdata.get('order_ids'));
      this.orderService.orderDelete(formdata).subscribe(
        (data: any) => {
          if (this.authService.resultCodeError(data)) {
            return;
          }

          // 🔹 Instantly update local list and cache
          this.orders = this.orders.filter((o: any) => o.id !== orderId);
          this.allOrders = [...this.orders];
          localStorage.setItem('ordersCache', JSON.stringify(this.orders));

          this.triggerBulkRefresh();
          this.toast.show('success', data.resultDescription);
          this.updateSelectionCount();
          this.fetchOrderCounts();
        },
        (error) => {
          this.authService.dataError(error);
        }
      );
    }
  }
  /**
   * Get status badge class
   */
  getStatusClass(status: string): string {
    return `status-badge ${status}`;
  }

  /**
   * Get filter count
   */
  getFilterCount(filter: string): number {
    switch (filter) {
      case 'all': return this.totalOrderscount;
      case 'pending': return this.pendingCount;
      case 'successful': return this.successfulCount;
      case 'unsuccessful': return this.unsuccessfulCount;
      case 'cancelled': return this.cancelledCount;
      default: return 0;
    }
  }

  hideTodaysDelivery = false;
  lastScrollTop = 0;

  // @HostListener('window:scroll', [])
  // onWindowScroll() {
  //   const scrollTop =
  //     window.pageYOffset || document.documentElement.scrollTop;

  //   // Scroll Down → Hide
  //   if (scrollTop > this.lastScrollTop && scrollTop > 120) {
  //     this.hideTodaysDelivery = true;
  //   }
  //   // Scroll Up → Show
  //   else {
  //     this.hideTodaysDelivery = false;
  //   }

  //   this.lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
  // }
  @ViewChild('tableContainer', { static: false }) tableContainer!: ElementRef;
  goToOrderDetail(id: number | string, order_status: string): void {

    if (order_status === 'warehouse') {
      this.orderDetail(id);
      return;
    }

    const scrollPos = this.tableContainer?.nativeElement?.scrollTop || 0;

    localStorage.setItem('orderListScroll', scrollPos.toString());
    localStorage.setItem('fromOrderDetail', 'true');

    this.router.navigate(['/admin/orders/order-detail', id]);

  }
  orderDatassss: any
  orderDetail(id: any) {
    this.orderService.orderDetail(id).subscribe(
      (data: any) => {
        if (this.authService.resultCodeError(data)) {
          return;
        }
        this.orderDatassss = data?.result;
        this.trackDriver();
      },
      (error) => {
        this.authService.dataError(error);
      }
    );
  }
  private trackDriverDialogRef: MatDialogRef<any> | null = null;
  private isOpeningTrackDriverDialog = false;
  trackDriver() {
    //  this.myFunction(this.title,'trackDriver');
    if (this.isOpeningTrackDriverDialog) return;
    this.isOpeningTrackDriverDialog = true;

    // Prevent reopening if already open
    if (this.trackDriverDialogRef) return;
    let enterAnimationDuration = '200ms';
    let exitAnimationDuration = '200ms';
    const dialogRef = this.dialog.open(ReusableGoogleMapComponent, {
      width: '1100px',
      height: '90vh',
      enterAnimationDuration,
      exitAnimationDuration,
      data: {
        height: '100%',
        isShowDirections: true,
        orderData: this.orderDatassss
      },
    });
    dialogRef.afterClosed().subscribe(dialogResult => {
      this.trackDriverDialogRef = null;
      this.isOpeningTrackDriverDialog = false;
      if (dialogResult) {

      }
    });

  }
  formattedOrderIds(item: any): string {
    let ids = '';

    if (item?.order_type === 'pickup' && item?.pickup_multiple_order_ids) {
      ids = item.pickup_multiple_order_ids;
    } else if (item?.order_type === 'delivery' && item?.dely_multiple_order_ids) {
      ids = item.dely_multiple_order_ids;
    }
    else if (item?.order_type === 'pickup' && item?.dely_multiple_order_ids && item.parent_order != null) {
      ids = item.dely_multiple_order_ids;
    }

    return ids.replace(/,/g, ', ');
  }
  convertToLocalDate(utcDateString: string | null, isStacked: boolean = false): string {
    if (!utcDateString) {
      return ''; // Or any default value you prefer
    }

    const datePipe = new DatePipe('en-US');
    const utcDate = new Date(utcDateString);
    const currentYear = new Date().getFullYear();

    if (utcDate.getFullYear() !== currentYear) {
      const dateStr = datePipe.transform(utcDate, 'EEE MMM dd') || '';
      const yearStr = datePipe.transform(utcDate, 'yyyy') || '';
      if (isStacked) {
        return `${dateStr}<br><span style="font-size: 11px; opacity: 0.85; font-weight: 500; display: block; margin-top: 1px;">${yearStr}</span>`;
      }
      return `${dateStr} ${yearStr}`;
    }

    return datePipe.transform(utcDate, 'EEE MMM dd') || '';
  }
  convertTime24To12(val: any) {
    if (val != 'null' && val != '' && val) {
      let timeWithout00 = val.split(':');
      var time: any = timeWithout00[0] + ':' + timeWithout00[1];
      time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

      if (time.length > 1) { // If time format correct
        time = time.slice(1);  // Remove full string match value
        time[5] = +time[0] < 12 ? ' AM' : ' PM'; // Set AM/PM
        time[0] = +time[0] % 12 || 12; // Adjust hours
      }

      return time.join('');
    }

  }
  getDriverInitials(driver: any): string {
    if (!driver || !driver.first_name || !driver.last_name) {
      return '';
    }

    const first = driver.first_name.charAt(0).toUpperCase();
    const last = driver.last_name.charAt(0).toUpperCase();

    return first + last;
  }
  getDriverDisplayName(driver: any): string {
    if (!driver || !driver.first_name) {
      return '';
    }

    const isVirtual = driver.is_virtual_user ||
      driver.first_name.toLowerCase().includes('truck') ||
      driver.first_name.toLowerCase().includes('zone') ||
      (driver.last_name && driver.last_name.toLowerCase().includes('truck')) ||
      (driver.last_name && driver.last_name.toLowerCase().includes('zone'));

    const hasNumbers = /\d/.test(driver.first_name) || (driver.last_name && /\d/.test(driver.last_name));

    if (isVirtual || hasNumbers) {
      return `${driver.first_name}${driver.last_name ? ' ' + driver.last_name : ''}`.trim();
    }

    // ---- Handle first name with multiple words ----
    const firstParts = driver.first_name.trim().split(' ');

    let name = this.capitalize(firstParts[0]); // first word full

    // baaki first name ke words ke initials
    for (let i = 1; i < firstParts.length; i++) {
      if (firstParts[i]) {
        name += ' ' + firstParts[i].charAt(0).toUpperCase();
      }
    }

    // ---- Middle name initial ----
    if (driver.middle_name) {
      name += ' ' + driver.middle_name.charAt(0).toUpperCase();
    }

    // ---- Last name initial ----
    if (driver.last_name) {
      name += ' ' + driver.last_name.charAt(0).toUpperCase();
    }

    return name;
  }

  capitalize(value: string): string {
    return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
  }
  userTimeZone: any;
  getUserTimeZone() {
    this.userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
  formatETDA(etda: string): string {
    // Check if etda includes '-', if true, format the date, otherwise return etda
    if (etda.includes('-')) {
      const [datePart, timePart] = etda.split(' '); // Splitting date and time parts
      const [year, month, day] = datePart.split('-').map(part => parseInt(part));
      const [hour, minute, second] = timePart.split(':').map(part => parseFloat(part)); // using parseFloat for seconds to handle fractional seconds

      const utcDate = new Date(Date.UTC(year, month - 1, day, hour, minute, second)); // Creating Date object with UTC date and time
      const localDate = new Date(utcDate.toLocaleString('en-US', { timeZone: this.userTimeZone })); // Converting to local timezone dynamically

      return localDate.toLocaleString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true });
    } else {
      return etda;
    }
  }


  formatETDAs(item: any): string {
    // Check if "arrived" status is present in status history
    for (const statusItem of item.status_history) {
      if (statusItem.status === 'arrived') {
        // Extract the timestamp for "arrived" status
        const timestampUtc = statusItem.created_at;
        // Convert to Date object
        const dtObj = new Date(timestampUtc);
        // Convert to 12-hour format
        const timestamp12hr = dtObj.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });
        return timestamp12hr;
      }
    }
    return ''; // Return empty string if "arrived" status not found
  }
  shouldShowETA(item: any): boolean {
    if (!item || !item.order_status) return false;

    const validStatus = ['en-route', 'shipped', 'warehouse', 'pending'];

    return (
      validStatus.includes(item.order_status) &&
      item.eta &&
      item.eta.length > 0 &&
      item.eta[0] &&
      item.eta[0].etda
    );
  }
  shouldShowArrived(order: any): boolean {
    // Sirf current status arrived ho tabhi chale
    if (!order || order.order_status !== 'arrived') {
      return false;
    }

    // Aur status_history me arrived ka time hona chahiye
    if (order.status_history && order.status_history.length > 0) {
      return order.status_history.some((status: any) =>
        status.status === 'arrived' && status.created_at
      );
    }

    return false;
  }

  getColor(item: any | null): string {
    if (item === null || item.dely_time === undefined || item.order_status === undefined) {
      return 'black'; // Handle case where item or its properties are null or undefined
    }
    if (item.order_type == 'delivery') {
      var delyTime = this.convertTime24To12(item.dely_time);
    }
    if (item.order_type == 'pickup') {
      var delyTime = this.convertTime24To12(item.pickup_time);
    }
    if (!delyTime) {
      return 'black'; // Handle case where delyTime is null or undefined
    }

    const orderTime = this.getDateTime(item, item.order_status);
    if (!orderTime || orderTime === 'NA') {
      return 'black';
    }
    const datePipe = new DatePipe('en-US');
    const transformedDate = datePipe.transform(orderTime, 'shortTime');

    if (!transformedDate) {
      return 'black'; // Handle case where transformedDate is null
    }

    const [hours, minutes, period] = delyTime.split(/:| /);
    let hoursInt = parseInt(hours);
    let minutesInt = parseInt(minutes);
    minutesInt += 30;

    if (minutesInt >= 60) {
      hoursInt += Math.floor(minutesInt / 60);
      minutesInt %= 60;
    }

    let newPeriod = period;
    if (hoursInt >= 12) {
      if (period === "am") {
        newPeriod = "pm";
      } else {
        newPeriod = "am";
      }
    }

    const newDelyTime = `${hoursInt}:${minutesInt.toString().padStart(2, '0')} ${newPeriod} `;



    const newDelyTimeObj = new Date('2000-01-01 ' + newDelyTime);
    const transformedDateObj = new Date('2000-01-01 ' + transformedDate);

    return newDelyTimeObj < transformedDateObj ? 'red' : 'green';
  }
  getDateTime(item: any, status?: string) {
    var sitem = item?.status_history.find((item: any) => item.status === status);

    if (sitem) {
      return sitem.updated_at;
    } else {
      return "NA";
    }
  }
  getFirstPart(time: string | null): string | undefined {
    // Check if time is null, empty, or "0"
    if (!time || time.trim() === "0") {
      //console.error("Invalid time value:", time);
      return undefined;
    }

    // console.log(time);

    // Split the time string based on spaces
    const parts = time.split(" ");

    // Extract the numeric value and unit from the parts
    const value = parseFloat(parts[0]);
    const unit = parts[1].toLowerCase(); // Normalize to lowercase for comparison

    let minutes: number;

    // Convert hours to minutes if the unit is hour(s) or hr(s)
    if (unit === "hours" || unit === "hour" || unit === "hrs" || unit === "hr") {
      minutes = Math.floor(value * 60);
    }
    // Convert days to minutes if the unit is day(s)
    else if (unit === "days" || unit === "day") {
      minutes = Math.floor(value * 24 * 60);
    }
    // If the unit is already in minutes, return the value
    else if (unit === "minutes" || unit === "minute" || unit === "mins" || unit === "min") {
      minutes = Math.floor(value);
    }
    // If the unit is unknown, log an error and return undefined
    else {
      // console.error("Unknown time unit:", unit);
      return undefined;
    }

    return minutes.toString();
  }
  getTimeUnit(minutes: string | undefined): string {
    if (!minutes) {
      return '';
    }

    const timeValue = parseInt(minutes, 10);
    return timeValue === 1 ? 'min' : 'mins';
  }
  isChipActive(status: string): boolean {

    // agar niche se kuch bhi select nahi → All active
    if (this.selectedStatuses.length === 0) {
      return status === 'all';
    }

    // multiple selected → jo-jo selected wahi active
    return this.selectedStatuses.includes(status);
  }
  driverList: any;
  getDriversForReassign(): void {
    let formattedDate = '';
    if (this.orderDate) {
      const parts = this.orderDate.split('-');
      if (parts.length === 3) {
        formattedDate = `${parts[2]}-${parts[1]}-${parts[0]}`;
      }
    }
    this.orderService.getActiveDriversForReassignAll('all', formattedDate || undefined).subscribe({
      next: (res: any) => {
        const driversMap = new Map();

        // 1. Handle Special Group Info
        // Skip "Trucks" category name to avoid redundant entries in the filter
        if (res?.result?.special_group_info) {
          const sg = res.result.special_group_info;
          if (sg.name && sg.name.toLowerCase() !== 'trucks') {
            driversMap.set(`sg_${sg.id}`, {
              id: sg.id,
              first_name: sg.name,
              last_name: '',
              isSpecial: true,
              is_virtual_user: false
            });
          }
        }

        // 2. Add Results
        const allResults = res?.result?.results || [];
        allResults.forEach((data: any) => {
          if (!driversMap.has(data.id)) {
            driversMap.set(data.id, {
              ...data,
              id: data.id,
              first_name: data.first_name,
              last_name: data.last_name || '',
              isOnline: data.is_online,
              activity_status: data.activity_status,
              is_virtual_user: data.is_virtual_user
            });
          }
        });

        this.driverList = Array.from(driversMap.values());
      },
      error: (err: any) => {
        console.error('Error while fetching driver list', err);
      }
    });
  }

  toggleTruckGroup(event: MouseEvent): void {
    event.stopPropagation();
    this.isTruckExpanded = !this.isTruckExpanded;
  }

  toggleZoneGroup(event: MouseEvent): void {
    event.stopPropagation();
    this.isZoneExpanded = !this.isZoneExpanded;
  }

  onDriverChange(driverId: any, event: any): void {
    const checked = event.target.checked;

    if (checked) {
      // checkbox select hua → add kar do
      if (!this.selectedDrivers.includes(driverId)) {
        this.selectedDrivers.push(driverId);
      }
    } else {
      // checkbox unselect hua → remove kar do
      this.selectedDrivers = this.selectedDrivers.filter(d => d !== driverId);
    }
    this.saveOrderListFiltersToLocalStorage();
    this.driverId = [...this.selectedDrivers];
    this.applyFilters();
  }

  clearDriverColumnFilter(): void {
    this.selectedDrivers = [];
    this.driverId = [];
    this.saveOrderListFiltersToLocalStorage();
    this.applyFilters();
  }

  clearStatusColumnFilter(): void {
    this.selectedStatuses = [];
    this.saveOrderListFiltersToLocalStorage();
    this.applyFilters();
  }
  saveOrderListFiltersToLocalStorage() {
    const filters = {
      orderDate: this.orderDate,
      selectedDrivers: this.selectedDrivers,
      selectedStatuses: this.selectedStatuses,
      searchText: this.searchtext,
      orderType: this.orderType,
      // aur bhi filter ho toh yahan add karein
    };
    localStorage.setItem('orderListFilters', JSON.stringify(filters));
  }
  getCurrentUrl: string = '';
  getPreviousUrl: string = '';
  restoreOrderListFiltersFromLocalStorage() {
    const filters = localStorage.getItem('orderListFilters');
    if (filters) {
      const parsed = JSON.parse(filters);
      this.orderDate = parsed.orderDate || '';
      this.selectedDrivers = parsed.selectedDrivers || [];
      this.selectedStatuses = parsed.selectedStatuses || [];
      this.searchtext = parsed.searchText || '';
      this.orderType = parsed.orderType || null;
      this.driverId = [...this.selectedDrivers];
      this.currentFilter = this.selectedStatuses.length > 0 ? this.selectedStatuses.join(',') : 'all';
    }

    // Only restore nextPageUrl when returning from detail, not on hard refresh
    if (this.isReturningFromDetail) {
      this.nextPageUrl = localStorage.getItem('nextPageUrl');
    } else {
      this.nextPageUrl = null;
      localStorage.removeItem('nextPageUrl');
    }
    // 🔹 currentPage will be restored via restoreOrdersFromCache for better sync

    localStorage.setItem('getCurrentUrl', this.navigationService.getCurrentUrl());
    localStorage.setItem('getPreviousUrl', this.navigationService.getPreviousUrl());
    this.getCurrentUrl = localStorage.getItem('getCurrentUrl') || '';
    this.getPreviousUrl = localStorage.getItem('getPreviousUrl') || '';
  }
  removeOrderListFiltersFromLocalStorage() {
    localStorage.removeItem('orderListFilters');
  }
  restoreOrdersFromCache(): boolean {
    // 🔹 Only restore cache if we are specifically returning from a detail page
    if (!this.isReturningFromDetail) return false;

    const cachedOrders = localStorage.getItem('ordersCache');
    const cachedTotal = localStorage.getItem('cachedTotalCount');
    const cachedPage = localStorage.getItem('cachedPage');

    if (!cachedOrders) return false;

    // 🔹 Restore Data
    this.orders = JSON.parse(cachedOrders);
    this.totalOrderscount = cachedTotal ? +cachedTotal : this.orders.length;
    this.totalOrders = this.totalOrderscount;
    this.currentPage = cachedPage ? +cachedPage : 0;

    this.syncOrdersSelection();

    const updatedOrder = localStorage.getItem('updatedOrder');
    if (updatedOrder) {
      const updatedObj = JSON.parse(updatedOrder);
      const index = this.orders.findIndex((o: any) => o.id === updatedObj.id);
      if (index !== -1) {
        this.orders[index] = { ...this.orders[index], ...updatedObj };
      }
      localStorage.setItem('ordersCache', JSON.stringify(this.orders));
      localStorage.removeItem('updatedOrder');
    }

    this.allOrders = [...this.orders];
    this.isLoading = false; // ✅ Immediately hide spinner to prevent flicker
    return true;
  }
  async onDrop(event: CdkDragDrop<any[]>) {
    const draggedIndex = event.previousIndex;
    const dropIndex = event.currentIndex;

    if (draggedIndex === dropIndex) return;

    const draggedItem = this.orders[draggedIndex];
    const dropTarget = this.orders[dropIndex];

    if (!draggedItem || !dropTarget) return;

    // Lock UI socket refreshes
    this.isProcessingDrop = true;

    try {
      // 1. Identify Target Group Context
      const targetDriverId = dropTarget.current_driver?.id || null;
      const targetDriverName = targetDriverId ?
        `${dropTarget.current_driver.first_name} ${dropTarget.current_driver.last_name}` :
        'Unassigned';

      const draggedDriverId = draggedItem.current_driver?.id || null;
      const isStatusPending = draggedItem.order_status === 'pending' && dropTarget.order_status === 'pending';

      if (!isStatusPending) {
        this.toast.show('error', 'Sorting is only allowed for pending orders.');
        return;
      }

      // 2. Date Transition Validation
      const formatDate = (date: any) => new DatePipe('en-US').transform(new Date(date), 'dd-MM-yyyy');
      const fromDate = formatDate(draggedItem.dely_date);
      const toDate = formatDate(dropTarget.dely_date);
      const isDateChanged = fromDate !== toDate;

      if (isDateChanged) {
        const confirmed = await this.dialogService.confirm(
          'Update Order Date',
          `Are you sure you want to change the date from <b>${fromDate}</b> to <b>${toDate}</b>?`,
          'Update',
          'Cancel'
        );
        if (!confirmed.confirmed) return;

        const dateFormData = new FormData();
        dateFormData.append('date', dropTarget.dely_date);
        await this.orderService.updateOrderDate(draggedItem.id, dateFormData).toPromise();
      }

      // 3. Handle Assignment Transitions (Unassign / Reassign / Assign)
      if (draggedDriverId !== targetDriverId) {
        let confirmMessage = '';
        let confirmTitle = '';
        let apiCall: any;

        if (draggedDriverId && !targetDriverId) {
          confirmTitle = 'Unassign Order';
          confirmMessage = 'Are you sure you want to Unassign this Order?';
          const fd = new FormData();
          fd.append('order_ids', JSON.stringify([Number(draggedItem.id)]));
          apiCall = () => this.orderService.orderunAssign(fd).toPromise();
        } else {
          confirmTitle = 'Assign Order';
          confirmMessage = `Are you sure you want to assign this order to ${targetDriverName}?`;
          const fd = new FormData();
          fd.append('order_ids', JSON.stringify([Number(draggedItem.id)]));
          fd.append('driver_id', targetDriverId);
          apiCall = () => this.orderService.orderAssign(fd).toPromise();
        }

        const confirmed = await this.dialogService.confirm(confirmTitle, confirmMessage, confirmTitle, 'Cancel');

        if (!confirmed.confirmed) {
          // If date was updated but assignment is cancelled, sync the UI date change
          if (isDateChanged) {
            this.triggerBulkRefresh();
          }
          return;
        }

        const res = await apiCall();
        if (this.authService.resultCodeError(res)) return;
        this.toast.show('success', res.resultDescription || 'Order updated successfully');
      }

      // 4. Unified Priority Calculation
      // Find all orders in the target group from the current visible list
      const targetGroupOrders = this.orders.filter((o: any) =>
        o.order_status === 'pending' &&
        (targetDriverId ? o.current_driver?.id === targetDriverId : !o.current_driver?.id)
      );

      // Find the relative index of the dropTarget within that specific group
      const targetGroupIndex = targetGroupOrders.findIndex((o: any) => o.id === dropTarget.id);
      const newPriority = targetGroupIndex + 1;

      // 5. Execute Priority Update
      const priorityFD = new FormData();
      priorityFD.append('order_id', draggedItem.id);
      priorityFD.append('priority', newPriority.toString());

      const data = await this.orderService.orderPriority(priorityFD).toPromise();
      if (this.authService.resultCodeError(data)) return;
      this.toast.show('success', data.result || 'Priority updated');

      // Final UI Sync
      moveItemInArray(this.orders, draggedIndex, dropIndex);
      this.triggerBulkRefresh();
      this.updateSelectionCount();
      this.fetchOrderCounts();
    } catch (error) {
      console.error('Error processing drop operation:', error);
      this.triggerBulkRefresh();
    } finally {
      this.isProcessingDrop = false;
    }
  }



  trackById(index: number, item: any) {
    return item?.id || index;
  }
  onItemMoved(id: any, status: any, driverid?: any) {
    this.idsss = id;
    this.sttusses = status;
    this.currentDriverId = driverid;
  }
  handleDragMoved(event: any, item: any): void {
    this.onItemMoved(item.id, item.order_status);
    const scrollContainer = this.tableContainer.nativeElement;
    const containerRect = scrollContainer.getBoundingClientRect();
    const pointerY = event.pointerPosition.y;

    if (pointerY < containerRect.top + this.scrollMargin) {
      scrollContainer.scrollTop -= this.scrollSpeed;  // scroll up
    } else if (pointerY > containerRect.bottom - this.scrollMargin) {
      scrollContainer.scrollTop += this.scrollSpeed;  // scroll down
    }

    // 🔹 Existing logic (uncomment if needed)
    // if (this.is_shipped_admin) {
    //   this.onItemMoved(item.id, item.order_status);
    //   this.onDragMove(event);
    // }
  }
  showAssignOrderModal = false;
  showAssign = false;
  selectedOrders: string[] = [];
  assignorder: boolean = false;
  openAssignOrder() {
    this.assignorder = true
    this.showAssign = true;
    const ids = this.orders
      .filter((o: any) => o.selected)
      .map((o: any) => o.id);
    this.selectedOrders = ids;
    this.showAssignOrderModal = true;
  }
  openReAssignOrder() {
    this.assignorder = true
    this.showAssign = false;
    const ids = this.orders
      .filter((o: any) => o.selected)
      .map((o: any) => o.id);
    this.selectedOrders = ids;
    this.showAssignOrderModal = true;
  }


  handleAssignOrder(event: { driver: string, orders: string[] }) {
    console.log('Assigned Orders:', event.orders, 'to', event.driver);
    const isDriverValid = event.driver !== '';
    this.assignorder = false;
    if (!isDriverValid) {
      console.warn('Driver not selected!');
      // 🔹 You can set a variable to false
      this.assignorder = false;  // example variable
      return; // exit if driver not valid
    }
    const ids = this.orders
      .filter((o: any) => o.selected)
      .map((o: any) => o.id);
    const formdata = new FormData();
    formdata.append('order_ids', JSON.stringify(ids));
    formdata.append('driver_id', event.driver);  // ✅ yahin se aa raha hai

    this.orderService.orderAssign(formdata).subscribe(
      (data: any) => {
        if (this.authService.resultCodeError(data)) return;
        if (data.resultDescription) {
          this.toast.show('success', data.resultDescription);
        }

        // Remove assigned orders from the current view if they no longer match the active driver filter
        if (this.driverId && this.driverId.length > 0 && !this.driverId.includes(event.driver)) {
          this.orders = this.orders.filter((o: any) => !ids.includes(o.id));
          
          if (this.totalOrders !== undefined) {
             this.totalOrders = Math.max(0, this.totalOrders - ids.length);
          }
          if (this.totalOrderscount !== undefined) {
             this.totalOrderscount = Math.max(0, this.totalOrderscount - ids.length);
          }
          
          localStorage.setItem('ordersCache', JSON.stringify(this.orders));
        }

        this.clearSelection();
      },
      (error) => {
        this.authService.dataError(error);
      }
    );
    // Call API to assign orders here
  }
  totalPages: any;
  itemsPerPage: number = 20;
  getPaginationInfo() {
    // 🔹 Use the overall total orders count
    const total = this.totalOrders || this.totalOrderscount;

    if (!total || total === 0) {
      return (this.isLoading && this.orders.length === 0) ? 'Loading orders...' : 'No orders found';
    }

    const start = this.visibleRangeStart;
    // 🔹 Fallback: if range hasn't been calculated yet, default to showing the first page (20)
    const end = this.visibleRangeEnd === 0 ? Math.min(20, total) : Math.min(this.visibleRangeEnd, total);

    if (this.currentFilter == 'all') {
      return `Showing ${start} - ${end} of ${total} orders`;
    }

    // For specific filters, we use their respective counts
    const filterTotal = {
      'pending': this.pendingCount,
      'successful': this.successfulCount,
      'unsuccessful': this.unsuccessfulCount,
      'cancelled': this.cancelledCount,
      'en-route': this.enRouteCount,
      'shipped': this.shippedCount,
      'arrived': this.arrivedCount,
      'warehouse': this.warehouseCount
    }[this.currentFilter] || total;

    return `Showing ${start} - ${end} of ${filterTotal} orders`;
  }

  /**
   * 🔹 trackByOrderId: Mandatory for stable infinite scrolls
   * Prevents Angular from re-rendering unchanged DOM rows.
   */
  trackByOrderId(index: number, item: any): string {
    return item?.id ? item.id.toString() : index.toString();
  }
  dialogRef: any;
  trackOrder(id: any) {
    this.orderDetail(id);
    // console.log('this.orderdata', order)
    // //  this.myFunction(this.title,'trackDriver');
    // let enterAnimationDuration = '200ms';
    // let exitAnimationDuration = '200ms';
    // this.dialogRef = this.dialog.open(ReusableGoogleMapComponent, {
    //   width: '800px',
    //   height: '90vh',
    //   enterAnimationDuration,
    //   exitAnimationDuration,
    //   data: {
    //     height: '100%',
    //     isShowDirections: true,
    //     orderData: order
    //   },
    // });
    // this.dialogRef.afterClosed().subscribe((dialogResult: any) => {
    //   if (dialogResult) {

    //   }
    // });

  }
  getRowBorderStyle(order: any) {
    const pending = order?.pending_order_group_visuals;
    const driver = order?.driver_separator;

    // priority: driver first (swapped as per user request), then pending
    const visuals = driver || pending;
    const style: any = {};

    if (visuals?.underline || driver?.top_underline) {
      style['--separator-color'] = visuals?.color || driver?.color || '#FF0000';
    }

    if (visuals?.underline) {
      style['border-bottom'] = `1px solid ${visuals.color || '#FF0000'} !important`;
    } else {
      style['border-bottom'] = 'none';
    }

    if (driver?.top_underline) {
      style['border-top'] = `1px solid ${driver.color || '#FF0000'} !important`;
    }

    return style;
  }

  /**
   * 🔹 CENTRAL REFRESH LISTENER: Professional single-point update handler
   */
  private setupRefreshSubscription(): void {
    if (this.subscriptionRefresh) this.subscriptionRefresh.unsubscribe();

    this.subscriptionRefresh = this.ShareddtaServices.refreshdata$.subscribe((data: any) => {
      if (!data || !data.result) return;

      if (this.isProcessingDrop) {
        console.log('OrderSync: Skipping setupRefreshSubscription refresh because onDrop is in progress.');
        return;
      }

      const result = data.result;

      // 🔹 Detect if this is a List or a Single Order Update
      const isList = !!result.results;
      const isSingle = !!result.id;
      const forceRefresh = result.refresh !== false;

      console.log('OrderSync: WebSocket Message received', { isList, isSingle, forceRefresh, resultId: result.id });

      if (isList) {
        const freshOrders = (result.results || []).map((order: any) => {
          if (order.eta && !Array.isArray(order.eta)) order.eta = [order.eta];
          if (!order.eta) order.eta = [];
          return order;
        });

        const requestedPage = (result.page || 1) - 1;
        this.processedOrders(freshOrders, requestedPage, forceRefresh);

        this.totalOrders = result.count || this.totalOrders;
        this.totalOrderscount = this.totalOrders;
      }
      else if (isSingle) {
        // 🔹 Handle Single Order Update (like ETA changes)
        if (result.eta && !Array.isArray(result.eta)) result.eta = [result.eta];

        if (forceRefresh) {
          console.log('OrderSync: Single item status change. Triggering Bulk Refresh.');
          this.triggerBulkRefresh();
        } else {
          this.processedOrders([result], null, false);
        }
      }

      this.syncOrdersSelection();
      localStorage.setItem('cachedTotalCount', this.totalOrders.toString());
      this.triggerOrderCountDebounce();
    });
  }

  /**
   * 🔹 UNIFIED SOURCE OF TRUTH: handles all data updates (HTTP, WS, Cache)
   * ID-Aware, reference-stable, and duplicate-proof.
   */
  private processedOrders(newOrders: any[], pageIndex: number | null, forceReorder: boolean, isReset: boolean = false): void {
    // 🔒 GUARD: If it's a reset (Search/Filter), we allow empty results to clear the screen
    // If it's a sync/pagination, we ignore nulls to prevent flickering.
    if (!newOrders || (newOrders.length === 0 && !isReset && !forceReorder)) return;

    // 🏆 UX IMPROVEMENT: If this is a reset, we throw away the old list entirely 
    // to match the new context (Search/Tab). 
    // If it's a sync, we patch.
    let currentList = isReset ? [] : [...this.orders];
    const isPageZeroRefresh = pageIndex === 0;

    if (pageIndex !== null) {
      console.log('OrderSync: Processing Orders Bulk', { count: newOrders.length, pageIndex, forceReorder, isReset });
      const pageSize = 20;
      const startIndex = pageIndex * pageSize;

      if (isReset) {
        // FULL OVERWRITE for search/filters
        currentList = [...newOrders];
      }
      else if (isPageZeroRefresh && forceReorder) {
        console.log('OrderSync: Applying Reconstruct Strategy for Page 0');
        const refreshedIds = new Set(newOrders.map(o => o.id));
        const oldMap = new Map(currentList.map(o => [o.id, o]));

        const updatedRange = newOrders.map(fresh => {
          const existing = oldMap.get(fresh.id);
          if (existing) {
            // Update in-place to keep DOM reference
            Object.keys(fresh).forEach(key => {
              if (JSON.stringify(existing[key]) !== JSON.stringify(fresh[key])) {
                existing[key] = fresh[key];
              }
            });
            return existing;
          }
          return fresh;
        });

        // residualList = everything after the refreshed range EXCEPT items that moved into the refresh range
        const residualList = currentList.filter((o, idx) => idx >= updatedRange.length && !refreshedIds.has(o.id));
        currentList = [...updatedRange, ...residualList];

      } else {
        // 🔹 INCREMENTAL / PATCHING (For standard pagination or refresh=false)
        newOrders.forEach((fresh, i) => {
          const idx = startIndex + i;
          const existingIdx = currentList.findIndex(o => o.id === fresh.id);

          if (existingIdx !== -1) {
            const existing = currentList[existingIdx];
            Object.keys(fresh).forEach(key => {
              if (JSON.stringify(existing[key]) !== JSON.stringify(fresh[key])) {
                existing[key] = fresh[key];
              }
            });

            if (forceReorder && existingIdx !== idx) {
              currentList.splice(existingIdx, 1);
              if (idx < currentList.length) {
                currentList.splice(idx, 0, existing);
              } else {
                currentList.push(existing);
              }
            }
          } else {
            if (idx < currentList.length) {
              currentList[idx] = fresh;
            } else {
              currentList.push(fresh);
            }
          }
        });

        // Individual staleness check if it was a bulk refresh but we opted for patching
        if (isPageZeroRefresh) {
          const newIds = new Set(newOrders.map(o => o.id));
          currentList = currentList.filter((item, index) =>
            index < newOrders.length ? newIds.has(item.id) : true
          );
        }
      }
    } else {
      // 🔹 SINGLE order update (pageIndex is null)
      newOrders.forEach(fresh => {
        const existingIdx = currentList.findIndex(o => o.id === fresh.id);
        if (existingIdx !== -1) {
          const existing = currentList[existingIdx];
          Object.keys(fresh).forEach(key => {
            if (JSON.stringify(existing[key]) !== JSON.stringify(fresh[key])) {
              existing[key] = fresh[key];
            }
          });
        }
      });
    }

    this.orders = currentList;
    this.allOrders = [...this.orders];
    this.isLoading = false; // 🔓 Load complete!
    this.syncOrdersSelection(); // Ensure checkbox states are maintained
    localStorage.setItem('ordersCache', JSON.stringify(this.orders));

    // 🏁 DATA-DRIVEN UNLOCK: Finish atomic return flow when data matches window
    if (this.isSyncingReturnFlow && isPageZeroRefresh) {
      console.log('OrderSync: Atomic Sync complete. Unlocking UI.');
      this.isSyncingReturnFlow = false;
      this.isReturningFromDetail = false;
    }
  }

  /**
   * 🔹 TRIGGER BULK REFRESH: Syncs all visible data in one shot.
   * Based on current scroll progress (currentPage), it requests all pages from 0.
   */
  getOrderZone(order: any): string {
    if (order?.current_driver?.is_deleted === true) {
      return order.current_driver.first_name || '';
    }
    return '';
  }

  getParentZone(order: any): string {
    const zone = this.getOrderZone(order);
    if (!zone) return '';
    const name = zone.toLowerCase().trim();
    if (name === 'north' || name === 'northeast' || name === 'northwest') {
      return 'North';
    }
    if (name === 'south' || name === 'southeast' || name === 'southwest') {
      return 'South';
    }
    if (name === 'east') {
      return 'East';
    }
    if (name === 'west') {
      return 'West';
    }
    return zone;
  }

  isSubZone(zoneName: string): boolean {
    if (!zoneName) return false;
    const name = zoneName.toLowerCase().trim();
    return name === 'northeast' || name === 'northwest' || name === 'southeast' || name === 'southwest';
  }

  formatZoneName(name: string): string {
    if (!name) return '';
    const trimmed = name.trim();
    const lower = trimmed.toLowerCase();
    if (lower === 'southeast') return 'SE';
    if (lower === 'northeast') return 'NE';
    if (lower === 'northwest') return 'NW';
    if (lower === 'southwest') return 'SW';
    return trimmed;
  }

  getOrderDate(order: any): string {
    return this.convertToLocalDate(order?.dely_date);
  }

  getZoneColorClass(zoneName: string): string {
    if (!zoneName) return 'zone-default';
    // Resolve back to the parent zone first to ensure consistent coloring
    const parentZone = this.isSubZone(zoneName) ? this.getParentZone({ current_driver: { is_deleted: true, first_name: zoneName } }) : zoneName;
    const name = parentZone.toLowerCase().trim();
    if (name.includes('east')) return 'zone-east';
    if (name.includes('west')) return 'zone-west';
    if (name.includes('north')) return 'zone-north';
    if (name.includes('south')) return 'zone-south';
    return 'zone-default';
  }


  private triggerBulkRefresh(): void {
    const currentLoadedCount = (this.currentPage + 1) * 20;
    this.websocketRefresh.sendOrderListRequest({
      page: 0,
      page_size: currentLoadedCount,
      search_text: this.searchtext || '',
      order_date: this.orderDate || '',
      order_status: this.currentFilter === 'all' ? null : this.currentFilter,
      order_type: this.orderType || '',
      driver_ids: this.driverId || []
    });
  }
}

